module.exports = __webpack_public_path__ + "img/Timeline_updated_12022020.768428cf.png";